import React from 'react';
import {Toast, InputItem, List} from 'antd-mobile';
import Marker from './Marker';

const style = {
    textIndent: 8
}
class Location extends React.Component{
    constructor(props){
        super(props);
    
        this.state = {
            amapAvailable: false,
            autocomplete: null,
            tips: [],
            searchText: ''
        }
    }
    componentDidMount(){
        let protocol = window.location.protocol;
        let url = `${protocol}//webapi.amap.com/maps?v=1.4.8&key=${atob('NmRlMmUwYzcwMDUzNDM4OGVhYTYyMTI2YjQxMWU4ZWY=')}`;
        let $script = document.createElement('script');
        $script.onload = ()=>{
            let interval = setInterval(()=>{
                let AMap = window.AMap;

                if (AMap){
                    clearInterval(interval);
                }else{
                    return;
                }
                
                this.setState({
                    amapAvailable: true
                })
                if (AMap.plugin) {
                    AMap.plugin('AMap.Autocomplete', ()=>{//回调函数
                    //实例化Autocomplete
                        let autocomplete= new AMap.Autocomplete({
                            city: "" //城市，默认全国
                        });
                        this.setState({
                            autocomplete
                        })
                        //TODO: 使用autocomplete对象调用相关功能
                    });
                };
            }, 1000)
            
        }
        $script.type = "text/javascript";
        document.body.appendChild($script);
        $script.src = url;
    }
    onUpdateInput = (keyword)=>{
        let autocomplete = this.state.autocomplete;
        this.selected = false;
        autocomplete && autocomplete.search(keyword, (status, result)=>{
            if ('complete' === status ){
                // 过滤
                let tips = result.tips;
                tips = tips.filter((tip)=>{
                    return !!tip.location;
                });
                //渲染列表
                this.setState({
                    tips
                })
            }else if ('error' === status){
                this.setState({
                    tips: []
                })
                keyword && Toast.info(result, 1.5);
            }else { // no_data
                this.setState({
                    tips: []
                })
            }
        });
        this.setState({
            searchText: keyword
        })
    }

    // 回填
    close = (keyword)=>{

        // TODO: fix
        let me = this;
        if(keyword === '') {
            let onChange = this.props.onChange;
            let value = undefined;
            onChange && onChange(value);
        }

        // close 先于 selectTip执行； 手动延迟
        setTimeout(()=>{
            let searchText = "";
            // 复原以前的选择
            let value = me.props.value;
            let arr =  value && value.split('#%$');
            if (arr && arr.length) {
                searchText = arr[2];
            }

            if (!me.selected){
                // 普通失焦
                if (keyword === '') {
                    // 删除
                    me.setState({
                        tips: [],
                        searchText: ''
                    })
                }else {
                    me.setState({
                        tips: [],
                        searchText: searchText
                    })
                }
            }else {
                // 点击后失焦

                me.setState({
                    tips: [],
                    searchText: searchText
                })
            }
        },1000)
    }

    onSelectTip = (index)=>{
        let tips = this.state.tips;
        
        let tip = tips[index];
        if (index === -1){
            return;
        }
        this.selected = true;
        let onChange = this.props.onChange;
        let location = tip.location;
        let value = [location.lng, location.lat,  `${tip.district}${tip.address}${tip.name}`].join('#%$');
        onChange && onChange(value);

        this.close();
    }
    render(){
        let {searchText, tips, amapAvailable} = this.state;
        let { value, errorText, api_name} = this.props;
        
        let tipsList = tips.map((tip)=>{
            return `${tip.district}${tip.address}${tip.name}`
        });

        let arr =  value && value.split('#%$');
        let lat, lng;  //默认天安门
        if (arr && arr.length) {
            lng = arr[0];
            lat = arr[1];
        }

        let tempProps = {
            placeholder: $st("请输入写字楼街道公司名称"),
            style: style,
            value: searchText
        }

        return ( 
            <div className="location">
                <InputItem className='map-tipstext' {...tempProps} onChange={this.onUpdateInput.bind(this)} onBlur={this.close.bind(this)} >
                    {errorText && <div className='input-error'>{errorText}</div>}
                </InputItem>
                <List className="location__list">
                    {tipsList.map((list, index) => {
                        return (
                            <List.Item onClick={() => this.onSelectTip(index)} key={index}>
                                {list}
                            </List.Item >
                        )
                    })}
                </List>  
                 
                {amapAvailable && <Marker apiname={api_name} lat={lat} lng={lng}/>}
            </div>
        )
    }
}

export default Location;


// WEBPACK FOOTER //
// ./src/component/Location/Location.js